/* eslint-disable max-lines */
import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { DataField, FormField } from './interfaces/AppProps';
import Form from './dmn/form/form';
import parseDmn from './utils/parseDmn';
import { Form as AntForm, Spin, Modal } from 'antd';
// import { Resizable } from 'react-resizable'
// import type { ResizeCallbackData } from 'react-resizable'
import CustomModal from './components/modal/modal';
import DmnValueSubmissionModal from './dmn/form/DmnValueSubmissionModal';
import ColumnAddModal from './dmn/form/ColumnAddModal';
import HeaderModal from './dmn/form/HeaderModal';
import VirtualizedDMNTable from './VirtualizedDMNTable';



const DmnGenerator = ({ xmlStructure, setXmlStructure, concatList, type, handleReset, dmnData, setDmnData, validationErrors, hasGridView = true,
  hasGridEdit = true,
  hasGridAddColumn = true,
  hasGridAddRow = true,
  hasShowGridFilter = true,
  // showReset = true
}: any) => {
    const [selectedRow, setSelectedRow] = useState<number>(0);
  const [selectedCol, setSelectedCol] = useState<number>(0);
  const [headerErrorModal, setheaderModalError] = useState('')
  const inputRefs = useRef<(HTMLInputElement | null)[][]>(
    Array.from({ length: 10 }, () => Array(5).fill(null))
  );
  const [inputEntryFormFields, setInputEntryFormFields] = useState<FormField[]>(
    [{
      name: '',
      type: '',
      start: '',
      end: '',
      includeStart: false,
      interval: ''
    }]);
  const [outputEntryFormFields, setOutputEntryFormFields] = useState<
    FormField[]
  >([{
    name: '', type: ''
  }]);
  const [editValue, setEditValue] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [fieldType, setFeildType] = useState('range');
  const [valueType, setValueType] = useState('');
  const [editHeader, setEditHeader] = useState('')
  const [columnList, setColumnList] = useState<FormField[]>([]);

  const [selectedColumn, setSelectedColumn] = useState<string>('');
  const [selectedColumnFrom, setSelectedColumnFrom] = useState('');
  const [selectedColumnFromType, setSelectedColumnFromType] = useState('');
  const [selectedColumnIndex, setSelectedColumnIndex] = useState<number | null>(
    null
  );
  const [showColumnModal, setShowColumnModal] = useState<boolean>(false);
  const [showHeaderModal, setShowHeaderModal] = useState(false);
  const [headerVal, setHeaderVal] = useState('')
  const [headerValFrom, setHeaderValFrom] = useState('')
  const [loading, setLoading] = useState(false)
  // const [openModal, setOpenModal] = useState(false);

  const isKeyPressed = useRef<boolean>(false);

  const [filterKeys, setFilterKeys] = useState<string[]>([]);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState<boolean>(false);

  useEffect(() => {
    if (concatList?.length > 0) {
      let list = concatList.filter(
        (obj, index, arr) => {
          return arr.findIndex(o => {
            return JSON.stringify(o) === JSON.stringify(obj)
          }) === index
        }
      )
      setColumnList(list)
    }
  }, [concatList])

  const hideModal = () => {
    setShowModal(false);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    // Check if dmnData exists and has data
    if (!dmnData?.data || dmnData.data.length === 0) {
      return;
    }

    if (isKeyPressed.current) return; // Prevent multiple triggers
    isKeyPressed.current = true;

    console.log('Key pressed:', event.key, 'Shift key pressed:', event.shiftKey);

    if (event.shiftKey) {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault(); // Prevent default behavior
          setSelectedRow((prev) => {
            const maxRow = dmnData.data.length - 1;
            const nextRow = prev < maxRow ? prev + 1 : prev;
            console.log('Selected Row:', nextRow);
            return nextRow;
          });
          break;

        case 'ArrowUp':
          event.preventDefault();
          setSelectedRow((prev) => {
            const nextRow = prev > 0 ? prev - 1 : prev;
            console.log('Selected Row:', nextRow);
            return nextRow;
          });
          break;

        case 'ArrowRight':
          event.preventDefault();
          setSelectedCol((prev) => {
            // Check if first row exists and has keys
            if (!dmnData.data[0] || typeof prev !== 'number') {
              return prev;
            }

            const columnKeys = Object.keys(dmnData.data[0]);
            const maxCol = columnKeys.length - 1;
            const nextCol = Math.min(prev + 1, maxCol);
            console.log('Selected Column:', nextCol);
            return nextCol;
          });
          break;

        case 'ArrowLeft':
          event.preventDefault();
          setSelectedCol((prev) => {
            if (typeof prev !== 'number') {
              return prev;
            }

            const nextCol = Math.max(prev - 1, 0);
            console.log('Selected Column:', nextCol);
            return nextCol;
          });
          break;

        default:
          break;
      }
    }
  };

  const handleKeyUp = () => {
    isKeyPressed.current = false; // Reset the flag when the key is released
  };

  useEffect(() => {
    // Attach the event listeners
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    // Cleanup the event listeners
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [dmnData]); // Keep dependency to re-attach listeners when data changes

  useEffect(() => {
    // Add comprehensive null checks for focusing
    if (
      inputRefs.current &&
      inputRefs.current[selectedRow] &&
      inputRefs.current[selectedRow][selectedCol] &&
      typeof selectedRow === 'number' &&
      typeof selectedCol === 'number' &&
      selectedRow >= 0 &&
      selectedCol >= 0
    ) {
      const targetRef = inputRefs.current[selectedRow][selectedCol];

      // Additional check to ensure the ref has a focus method
      if (targetRef && typeof targetRef.focus === 'function') {
        try {
          targetRef.focus();
        } catch (error) {
          console.warn('Failed to focus element:', error);
        }
      }
    }
  }, [selectedRow, selectedCol]);

  console.log(dmnData, 'dmnData');



  const headers =
    Object.keys(dmnData?.data)?.length > 0 && Object.keys(dmnData?.data?.[0]);

  const handleModalSubmit = () => {
    if (
      Array.isArray(dmnData?.data) &&
      selectedRow >= 0 &&
      selectedRow < dmnData?.data.length
    ) {
      const newData = [...(dmnData && dmnData.data ? dmnData.data : [])];
      const headerKey =
        Array.isArray(headers) &&
          selectedCol >= 0 &&
          selectedCol < headers.length
          ? headers[selectedCol]
          : undefined;
      if (typeof headerKey === 'string') {
        if (valueType === 'string') {
          let val;
          if (editValue.includes(',')) {
            val = editValue
              .split(',')
              .map((value) => `"${value.trim()}"`)
              .join(',');
          } else {
            val = `"${editValue}"`;
          }
          newData[selectedRow] = {
            ...newData[selectedRow],
            [headerKey]: fieldType === 'matchesNone' ? `not ${val} ` : val,
          };
        } else {
          newData[selectedRow] = {
            ...newData[selectedRow],
            [headerKey]: editValue,
          };
        }
      }
      setDmnData({ ...dmnData, data: newData });
    }
    setShowModal(false);
  };





  const handleAddColumn = (index: number, headerName: string) => {
    if (dmnData?.inputFields.some((item) => item.name === headerName)) {
      setheaderModalError('Same header already existing');
      return;
    }

    if (dmnData?.outputFields.some((item) => item.name === headerName)) {
      setheaderModalError('Same header already existing');
      return;
    }

    if (Array.isArray(headers)) {


      const newColumnName = headerName;
      const updatedData = dmnData?.data.map((row: any) => {
        const newRow = { ...row };
        const entries = Object.entries(newRow);
        const before = entries.slice(0, index + 1);
        const after = entries.slice(index + 1);
        return Object.fromEntries([...before, [newColumnName, ''], ...after]);
      });
      if (
        dmnData?.inputFields.some((field) => field.name === selectedColumnFrom)
      ) {
        setDmnData({
          ...dmnData,
          inputFields: [
            ...dmnData.inputFields,
            {
              name: newColumnName,
              type: columnList.filter((item) => item.name === headerName)?.[0]
                ?.type,
            },
          ],
          data: updatedData,
        });
        setHeaderSequence(Object.keys(updatedData[0]));

      } else {
        setDmnData({
          ...dmnData,
          outputFields: [
            ...dmnData.outputFields,
            { name: selectedColumn, type: selectedColumnFromType },
          ],
          data: updatedData,
        });
        setHeaderSequence(Object.keys(updatedData[0]));
      }
    }
    setShowColumnModal(false);
    setheaderModalError('')
    setSelectedColumn('')
    setSelectedColumnFromType('')
  };

  const [headerSequence, setHeaderSequence] = useState<string[]>([]);

  const handleHeaderColumnChange = (type) => {
    if (!Array.isArray(headers)) return;
    const headerFrom = headerValFrom;
    const replaceHeaderWith = type === 'input' ? headerVal : selectedColumn;
    // Check if the new header already exists
    if (dmnData?.inputFields.some((item) => item.name === replaceHeaderWith)) {
      setheaderModalError('Same header already existing');
      return;
    }

    if (dmnData?.outputFields.some((item) => item.name === replaceHeaderWith)) {
      setheaderModalError('Same header already existing');
      return;
    }
    // Update data rows - create new objects with the correct key order
    const updatedData = dmnData.data.map((row) => {
      if (row.hasOwnProperty(headerFrom)) {
        // Create a new object preserving the original order
        const newRow = {};
        // Go through all keys in the original order
        Object.keys(row).forEach(key => {
          if (key === headerFrom) {
            // When we hit the key we want to replace, add the new key instead
            newRow[replaceHeaderWith] = row[headerFrom];
          } else {
            // Keep all other keys as is
            newRow[key] = row[key];
          }
        });
        return newRow;
      }
      return row;
    });

    // No need for removeKey function since we're building new objects correctly

    // Update fields
    const fieldKey = type === 'input' ? 'inputFields' : 'outputFields';
    const updatedFields = dmnData[fieldKey].map((field) =>
      field.name === headerFrom ? { ...field, name: replaceHeaderWith, type: type === 'input' ? columnList?.find((item) => item.name === replaceHeaderWith)?.type || 'double' : selectedColumnFromType } : field
    );

    // Update state without altering header sequence
    setDmnData({
      ...dmnData,
      data: updatedData,
      [fieldKey]: updatedFields,
    });

    // Maintain the original header sequence
    setHeaderSequence((prev) => prev.map((h) => (h === headerFrom ? replaceHeaderWith : h)));

    setShowHeaderModal(false);
    setSelectedColumn('')
    setSelectedColumnFromType('')
  };

  console.log(dmnData, 'dmnData')

  useEffect(() => {
    const fetchData = async () => {
      if (xmlStructure.length > 0) {
        setLoading(true);
        let data = await parseDmn(xmlStructure);
        if (data) {

          setDmnData(data);
          setHeaderSequence(Object.keys(data?.data[0]));
        }
      }
    };
    fetchData();
  }, [xmlStructure]);

  useEffect(() => {
    if (dmnData?.data?.length > 0) {
      setLoading(false)
    }
  }, [dmnData])

  const onclose = () => {
    setSelectedColumn('')
    setSelectedColumnFrom('')
    setSelectedColumnFromType('')
    setSelectedColumnIndex(null)
    setHeaderVal('')
    setHeaderValFrom('')
    setheaderModalError('')
    setEditValue('')
  }

  // Function to handle modal close
  const handleFilterModalClose = () => {
    setIsFilterModalVisible(false);
  };

  if (loading) {
    return <Spin />
  }



  console.log(inputRefs, 'inputRefs')
  console.log(dmnData, 'dmnData')


  return (
    <div className='dmn-form-generator-parent'>
      {
        dmnData?.data?.length > 0 ?
          null
          :
          <Form
            inputRefs={inputRefs}
            inputEntryFormFields={inputEntryFormFields}
            setInputEntryFormFields={setInputEntryFormFields}
            outputEntryFormFields={outputEntryFormFields}
            setOutputEntryFormFields={setOutputEntryFormFields}
            setDmnData={setDmnData}
            columnList={columnList}
            setHeaderSequence={setHeaderSequence}
            setXmlStructure={setXmlStructure}
          />
      }

      <div className="table-parent">
        {Array.isArray(dmnData?.data) && dmnData.data.length > 0 ? (
          <AntForm disabled={false}>
            <VirtualizedDMNTable
              dmnData={dmnData}
              setDmnData={setDmnData}
              headerSequence={headerSequence}
              type={type}
              inputFields={dmnData.inputFields}
              outputFields={dmnData.outputFields}
              validationErrors={validationErrors}
              setSelectedRow={setSelectedRow}
              setSelectedCol={setSelectedCol}
              setValueType={setValueType}
              setEditHeader={setEditHeader}
              setEditValue={setEditValue}
              setFieldType={setFeildType}
              setShowModal={setShowModal}
              setHeaderSequence={setHeaderSequence}
              setSelectedColumnIndex={setSelectedColumnIndex}
              setSelectedColumnFrom={setSelectedColumnFrom}
              setShowColumnModal={setShowColumnModal}
              setSelectedColumnFromType={setSelectedColumnFromType}
              setSelectedColumn={setSelectedColumn}
              setHeaderVal={setHeaderVal}
              setHeaderValFrom={setHeaderValFrom}
              setShowHeaderModal={setShowHeaderModal}
              handleReset={handleReset}
                  hasGridView={hasGridView}
              hasGridEdit={hasGridEdit}
              hasGridAddColumn={hasGridAddColumn}
              hasGridAddRow={hasGridAddRow}
              hasShowGridFilter={hasShowGridFilter}
            />
          </AntForm>
        ) : null}
      </div>
      <CustomModal
        openModal={showModal}
        hideModal={() => { hideModal(); onclose() }}
        content={<DmnValueSubmissionModal editHeader={editHeader} dmnData={dmnData?.data} valueType={valueType} handleModalSubmit={handleModalSubmit} setFeildType={setFeildType} fieldType={fieldType} setEditValue={setEditValue} editValue={editValue} onClose={() => { hideModal(); onclose() }} />}
      />

      <CustomModal
        openModal={showColumnModal}
        hideModal={() => { setShowColumnModal(false); onclose() }}
        content={<ColumnAddModal dmnData={dmnData} setSelectedColumn={setSelectedColumn} selectedColumnFromType={selectedColumnFromType} selectedColumnFrom={selectedColumnFrom} columnList={columnList} selectedColumnIndex={selectedColumnIndex} headerErrorModal={headerErrorModal} handleAddColumn={handleAddColumn} setShowColumnModal={setShowColumnModal} selectedColumn={selectedColumn} setSelectedColumnFromType={setSelectedColumnFromType} />}
      />
      <CustomModal
        openModal={showHeaderModal}
        hideModal={() => { setShowHeaderModal(false); onclose() }}
        content={<HeaderModal selectedColumn={selectedColumn}
          setSelectedColumn={setSelectedColumn}
          setSelectedColumnFromType={setSelectedColumnFromType}
          selectedColumnFromType={selectedColumnFromType}
          selectedColumnIndex={selectedColumnIndex}
          handleAddColumn={handleAddColumn} dmnData={dmnData} handleHeaderColumnChange={handleHeaderColumnChange} headerVal={headerVal} setheaderModalError={setheaderModalError} setHeaderVal={setHeaderVal} columnList={columnList} headerErrorModal={headerErrorModal} headerValFrom={headerValFrom} setShowHeaderModal={setShowHeaderModal} />}
      />

      {/* Modal to show applied filter keys */}
      <Modal
        title="Remove the filters applied on the following key to change the position of row"
        visible={isFilterModalVisible}
        onCancel={handleFilterModalClose}
        footer={null}
      >

        <ul>
          {filterKeys.map((key) => (
            <li key={key}>{key}</li>
          ))}
        </ul>
      </Modal>
    </div>
  );
};

export default DmnGenerator;
